export default __webpack_public_path__ + "static/media/eb-ultra-pro-banner-2.464f3d63.jpg";